import { RouteConfig } from 'vue-router'

import DashboardView from 'dashboard/DashboardView.vue'
import AlarmView from 'messages/alarm/AlarmView.vue'
import EventView from 'messages/event/EventView.vue'
import MessageView from 'messages/MessageView.vue'
import NewsView from 'messages/news/NewsView.vue'
import MessengerView from 'messenger/MessengerView.vue'

export const routes: RouteConfig[] = [
  {
    path: '/',
    redirect: '/dashboards'
  },
  {
    path: '/messenger',
    name: 'messenger',
    component: MessengerView
  },
  {
    path: '/dashboards',
    name: 'dashboards',
    component: DashboardView,
    children: [
      {
        path: 'alarm/:alarmId',
        name: 'alarmDashboard'
      }
    ]
  },
  {
    path: '/messages',
    name: 'messages',
    component: MessageView,
    children: [
      {
        path: 'alarm/:alarmId',
        name: 'alarmIndex',
        component: AlarmView
      },
      {
        path: 'news/:newsId',
        name: 'newsIndex',
        component: NewsView
      },
      {
        path: 'event/:eventId',
        name: 'eventIndex',
        component: EventView
      }
    ]
  }
]
